<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type === 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
<!--    <div class="d-flex justify-content-end" v-if="TracksList.length > 0">-->
<!--      <b-button class="btnFilter_2 mx-3"-->
<!--        @click="extractCSV()">-->
<!--        <i class="fa-light fa-upload fs-14px"></i>-->
<!--        <span class="fab-label">{{ $t('common.extract_list') }}</span>-->
<!--      </b-button>-->
<!--    </div>-->
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TracksList.length > 0"  style="overflow:auto">
      <b-table :hover="false"
               class="table table-striped mb-0"
               :fields="fields"
               :items="TracksList"
               :selectable="false"
               :empty-text="$t('common.security.no_result')">
        <template #cell(DateImport)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(DateLastUpdate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>

        <template #cell(Active)="data">
          <span>{{ $t('annuaire.active_'+data.value)}}</span>
        </template>
        <template #cell(Data)="data">
          <div class="d-flex">

            <div class="" v-if="data.item.FirstName1 !== '' || data.item.LastName1 !== '' || data.item.MarriedName1 !== '' || data.item.BirthName1 !== ''">
              <span>{{ $t('annuaire.label_pp_1')}}</span>
              <table class="annuaireTable">
                <tbody>
                <tr>
                  <th class="p-1" scope="row" :id="`firstname1-${data.item.id}`">{{ $t('annuaire.first_name') }}:</th>
                  <td class="p-1" :headers="`firstname1-${data.item.id}`" :title="data.item.FirstName1">{{ data.item.FirstName1 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`lastname1-${data.item.id}`">{{ $t('annuaire.last_name') }}:</th>
                  <td class="p-1" :headers="`lastname1-${data.item.id}`" :title="data.item.LastName1">{{ data.item.LastName1 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`birthname1-${data.item.id}`">{{ $t('annuaire.birth_name') }}:</th>
                  <td class="p-1" :headers="`birthname1-${data.item.id}`" :title="data.item.BirthName1">{{ data.item.BirthName1 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`marriedname1-${data.item.id}`">{{ $t('annuaire.married_name') }}:</th>
                  <td class="p-1" :headers="`marriedname1-${data.item.id}`" :title="data.item.MarriedName1">{{ data.item.MarriedName1 }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="ml-4" v-if="data.item.FirstName2 !== '' || data.item.LastName2 !== '' || data.item.MarriedName2 !== '' || data.item.BirthName2 !== ''">
              <span>{{ $t('annuaire.label_pp_2')}}</span>
              <table class="annuaireTable">
                <tbody>
                <tr>
                  <th class="p-1" scope="row" :id="`firstname2-${data.item.id}`">{{ $t('annuaire.first_name') }}:</th>
                  <td class="p-1" :headers="`firstname2-${data.item.id}`" :title="data.item.FirstName2">{{ data.item.FirstName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`lastname2-${data.item.id}`">{{ $t('annuaire.last_name') }}:</th>
                  <td class="p-1" :headers="`lastname2-${data.item.id}`" :title="data.item.LastName2">{{ data.item.LastName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`birthname2-${data.item.id}`">{{ $t('annuaire.birth_name') }}:</th>
                  <td class="p-1" :headers="`birthname2-${data.item.id}`" :title="data.item.BirthName2">{{ data.item.BirthName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`marriedname2-${data.item.id}`">{{ $t('annuaire.married_name') }}:</th>
                  <td class="p-1" :headers="`marriedname2-${data.item.id}`" :title="data.item.MarriedName2">{{ data.item.MarriedName2 }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="" v-if="data.item.CompanyName !== '' || data.item.Siren !== '' || data.item.Siret !== '' || data.item.TVAIntracomm !== ''">
              <span>{{ $t('annuaire.label_pm_1')}}:</span>
              <table class="annuaireTable" >
                <tbody>
                <tr>
                  <th class="p-1" scope="row" :id="`companyname1-${data.item.id}`">{{ $t('annuaire.company_name') }}:</th>
                  <td class="p-1" :headers="`companyname1-${data.item.id}`" :title="data.item.CompanyName">{{ data.item.CompanyName }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`tradingname1-${data.item.id}`">{{ $t('annuaire.trading_name') }}:</th>
                  <td class="p-1" :headers="`tradingname1-${data.item.id}`" :title="data.item.TradingName">{{ data.item.TradingName }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`siren1-${data.item.id}`">{{ $t('annuaire.siren') }}:</th>
                  <td class="p-1" :headers="`siren1-${data.item.id}`" :title="data.item.Siren">{{ data.item.Siren }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`siret1-${data.item.id}`">{{ $t('annuaire.siret') }}:</th>
                  <td class="p-1" :headers="`siret1-${data.item.id}`" :title="data.item.Siret">{{ data.item.Siret }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`tva1-${data.item.id}`">{{ $t('annuaire.tva_intracomm') }}:</th>
                  <td class="p-1" :headers="`tva1-${data.item.id}`" :title="data.item.TVAIntracomm">{{ data.item.TVAIntracomm }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`lei1-${data.item.id}`">{{ $t('annuaire.lei') }}:</th>
                  <td class="p-1" :headers="`lei1-${data.item.id}`" :title="data.item.LEI">{{ data.item.LEI }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`euid1-${data.item.id}`">{{ $t('annuaire.euid') }}:</th>
                  <td class="p-1" :headers="`euid1-${data.item.id}`" :title="data.item.EUID">{{ data.item.EUID }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="ml-4" v-if="data.item.CompanyName2 !== '' || data.item.Siren2 !== '' || data.item.Siret2 !== '' || data.item.TVAIntracomm2 !== ''">
              <span>{{ $t('annuaire.label_pm_2')}}:</span>
              <table class="annuaireTable" >
                <tbody>
                <tr>
                  <th class="p-1" scope="row" :id="`companyname2-${data.item.id}`">{{ $t('annuaire.company_name') }}:</th>
                  <td class="p-1" :headers="`companyname2-${data.item.id}`" :title="data.item.CompanyName2">{{ data.item.CompanyName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`tradingname2-${data.item.id}`">{{ $t('annuaire.trading_name') }}:</th>
                  <td class="p-1" :headers="`tradingname2-${data.item.id}`" :title="data.item.TradingName2">{{ data.item.TradingName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`siren2-${data.item.id}`">{{ $t('annuaire.siren') }}:</th>
                  <td class="p-1" :headers="`siren2-${data.item.id}`" :title="data.item.Siren2">{{ data.item.Siren2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`siret2-${data.item.id}`">{{ $t('annuaire.siret') }}:</th>
                  <td class="p-1" :headers="`siret2-${data.item.id}`" :title="data.item.Siret2">{{ data.item.Siret2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`tva2-${data.item.id}`">{{ $t('annuaire.tva_intracomm') }}:</th>
                  <td class="p-1" :headers="`tva2-${data.item.id}`" :title="data.item.TVAIntracomm2">{{ data.item.TVAIntracomm2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`lei2-${data.item.id}`">{{ $t('annuaire.lei') }}:</th>
                  <td class="p-1" :headers="`lei2-${data.item.id}`" :title="data.item.LEI2">{{ data.item.LEI2 }}</td>
                </tr>
                <tr>
                  <th class="p-1" scope="row" :id="`euid2-${data.item.id}`">{{ $t('annuaire.euid') }}:</th>
                  <td class="p-1" :headers="`euid2-${data.item.id}`" :title="data.item.EUID2">{{ data.item.EUID2 }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download";
import BackButton from "@/components/common/backButton.vue";


export default {
  name: 'AnnuaireLineList',
  components: {
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      fields = [
        { key: 'BIC', label: this.$i18n.t('annuaire.bic'), class: 'text-center', sortable: false },
        { key: 'IBAN', label: this.$i18n.t('annuaire.iban'), class: 'text-center', sortable: false },
        { key: 'Data', label: this.$i18n.t('annuaire.data'), class: 'text-center', sortable: false },
        { key: 'DateImport', label: this.$i18n.t('annuaire.date_import'), class: 'text-center', sortable: false },
        { key: 'DateLastUpdate', label: this.$i18n.t('annuaire.date_last_update'), class: 'text-center', sortable: false },
        { key: 'FileName', label: this.$i18n.t('annuaire.file_name'), class: 'text-center', sortable: false },
        { key: 'Active', label: this.$i18n.t('annuaire.active'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.IBAN ||
          this.BIC ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      timezone: '+00:00',
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      technicalStatus: '',
      BIC: '',
      Name: '',
      IBAN: '',
      dateBegin: '',
      returnUrl: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: []
    }
  },
  created () {
    this.timezone = moment.tz.guess()

    if (this.type === 'BULK') {
      this.defineReturnURL()
    }
    // this.$bus.$emit('switch-selected-menu', '/annuaire/')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    // Écouter l'événement de recherche depuis le parent
    this.$bus.$off('apply-annuaire-filters')
    this.$bus.$on('apply-annuaire-filters', filters => {
      // Synchroniser les filtres puis déclencher la recherche
      if (filters) {
        this.Name = filters.Name || ''
        this.BIC = filters.BIC || ''
        this.IBAN = filters.IBAN || ''
        this.dateBegin = filters.dateBegin || ''
        this.dateEnd = filters.dateEnd || ''
        // Déclencher la recherche uniquement maintenant
        this.onRefresh()
      }
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().annuaire.cleanFilterCondition()
  },
  methods: {
    defineReturnURL () {
      let that = this
      this.returnUrl =  '/annuaire/file/' + this.id
    },
    applyFilter (filterConditions = {}) {
      this.TracksList = []
      let that = this
      this.filterTypeGet = 'list'
      this.$engine.firstOn().annuaire.cleanFilterCondition()

      if (this.id !== 'NULL') {
        filterConditions.IdAnnuaire = this.id
      }
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.BIC = this.BIC.trim()
      filterConditions.ByClient = 1

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.firstOn().annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
        that.paginationObject.nbResults = resp.data.annuaires.length
        resp.data.annuaires.forEach(item => {
          item.company_name = item.company_name
          item.statusVerification = item.statusVerification
          item.active = item.active
        })
        requests = resp.data.annuaires
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.Name = ''
      this.IBAN = ''
      this.BIC = ''
      this.dateEnd = ''
      this.dateBegin = ''
      this.communicateChange()
      // this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        ByClient: 1,
      }
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.BIC = this.BIC.trim()

      if (this.id !== 'NULL') {
        filterConditions.IdAnnuaire = this.id
      }
      this.$engine.firstOn().annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        this.TracksList = []
        let requests = {}
        if (resp.data && resp.data.annuaires.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
          that.paginationObject.nbResults = resp.data.annuaires.length
          requests = resp.data.annuaires
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    extractCSV (){
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        extract : 1,
      }

      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.Name = this.Name

      if (this.id !== 'NULL') {
        filterConditions.IdAnnuaire = this.id
      }
      this.$engine.firstOn().annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + resp.data
        const downloadLink = document.createElement('a')
        let today = moment.tz()
        const fileName = that.$t('Webheader.annuaire') + '_' + today.unix() + '.csv'
        if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      if (this.type === 'BULK') {
        type = this.id
      }
      loadPage(that, {url: '/annuairedetails/' + type +'/' + id})
    },
    reOrderBy (column) {
      this.TracksList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions


      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.BIC = this.BIC.trim()
      filterConditions.ByClient = 1

      if (this.id !== 'NULL'){
        filterConditions.IdAnnuaire = this.id
      }
      this.$engine.firstOn().annuaire.getAnnuaires(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
        that.paginationObject.nbResults = resp.data.annuaires.length
        resp.data.annuaires.forEach(item => {
          item.statusVerification = item.statusVerification
          item.company_name = item.company_name
          item.active = item.active
        })
        requests = resp.data.annuaires
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.TracksList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeTracksDetails (items) {
      this.activateDetail(items[0].IdTrack)
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm.ss.SSS');
    },
    showButtonImportLot () {
      return false
    }
  },
  watch: {
    filters: {
      handler(newFilters) {
        if (newFilters && typeof newFilters === 'object') {
          // Synchroniser les filtres avec les props du parent SANS déclencher la recherche
          this.Name = newFilters.Name || ''
          this.BIC = newFilters.BIC || ''
          this.IBAN = newFilters.IBAN || ''
          this.dateBegin = newFilters.dateBegin || ''
          this.dateEnd = newFilters.dateEnd || ''
        }
      },
      deep: true,
      immediate: false
    }
  }
}
</script>
